import moment from 'moment';
import { FaCheckCircle, FaExclamationTriangle, FaInfoCircle, FaTimesCircle } from 'react-icons/fa';

import { formatDateTime } from 'v3/utils/formatter';

export const ICONS = {
  error: FaTimesCircle,
  warning: FaExclamationTriangle,
  success: FaCheckCircle,
  info: FaInfoCircle,
};

export function formatLogDate(value) {
  if (!value || !moment(value).isValid()) {
    return 'Data não informada';
  }

  return formatDateTime(value);
}

const STATUS_BY_ID = {
  1: 'PENDING',
  2: 'SUCCESS',
  3: 'FAILED',
};

const INTEGRATION_LOGS_KEY = /^(\w+)IntegrationLogs$/;

// Nome exibido de cada integração. Chaves novas sem entrada aqui usam o prefixo capitalizado.
const PROVIDER_LABELS = {
  raster: 'Raster',
  extratta: 'Extratta',
  benner: 'Benner',
  emiteai: 'EmiteAí',
};

function getStatusSlug(log) {
  return log?.status?.slug || STATUS_BY_ID[log?.integrationStatusId];
}

function hasMessage(log) {
  return Boolean(log?.errorMessage?.trim());
}

function getProviderLabel(provider) {
  return PROVIDER_LABELS[provider] || provider.charAt(0).toUpperCase() + provider.slice(1);
}

export function getIntegrationLogVariant(log) {
  const slug = getStatusSlug(log);

  if (slug === 'FAILED') {
    return { variant: 'error', label: 'Falha' };
  }

  if (slug === 'SUCCESS') {
    return hasMessage(log)
      ? { variant: 'warning', label: 'Sucesso com avisos' }
      : { variant: 'success', label: 'Sucesso' };
  }

  if (slug === 'PENDING') {
    return { variant: 'info', label: 'Pendente' };
  }

  return { variant: 'info', label: log?.status?.description || 'Desconhecido' };
}

const DEFAULT_MESSAGES = {
  success: 'Integrado com sucesso',
  info: 'Integração pendente',
  error: 'Falha sem mensagem informada',
};

export function getIntegrationLogMessage(log, variant) {
  if (hasMessage(log)) {
    return log.errorMessage.trim();
  }

  return DEFAULT_MESSAGES[variant] || DEFAULT_MESSAGES.info;
}

const SUMMARY_TEXTS = {
  success: 'Integrado com sucesso',
  warning: 'Integrado com sucesso',
  error: 'Falha na integração',
  info: 'Integração pendente',
};

// Resumo da integração pela tentativa mais recente (os logs chegam ordenados por id desc).
export function getIntegrationSummary(logs) {
  if (!logs?.length) {
    return { variant: 'empty', text: 'Nenhuma integração registrada', label: 'Sem registros' };
  }

  const { variant, label } = getIntegrationLogVariant(logs[0]);

  return { variant, label, text: SUMMARY_TEXTS[variant] };
}

// Agrupa os logs por integração a partir das chaves `<provider>IntegrationLogs` do cadastro.
export function groupIntegrationLogs(body) {
  const entity = body?.data?.[0];

  if (!entity) {
    return [];
  }

  return Object.keys(entity).reduce((groups, key) => {
    const match = key.match(INTEGRATION_LOGS_KEY);

    if (!match || !Array.isArray(entity[key])) {
      return groups;
    }

    return [...groups, { key: match[1], label: getProviderLabel(match[1]), logs: entity[key] }];
  }, []);
}
